import { IConfig } from "@unleash/proxy-client-react";

const url = import.meta.env.DEV
  ? "https://proxy-dev.unleash.numerous.com/proxy"
  : "https://proxy-prod.unleash.numerous.com/proxy";
const clientKey = import.meta.env.DEV
  ? "proxy-dev-zJB77rZhGQvFTA4C"
  : "proxy-prod-1qew7ZarYzxivHqo";
const appName = import.meta.env.DEV
  ? "numerous-web-app-local"
  : "numerous-web-app";

export const unleashConfig: IConfig = {
  url, // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
  clientKey, // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
  refreshInterval: 10, // How often (in seconds) the client should poll the proxy for updates
  appName // The name of your application. It's only used for identifying your application
};
